module.exports = __webpack_public_path__ + "static/media/SEBI_logo.svg.34f97fbc.png";